import { UrlFilterHelper } from "_helpers/UrlFilterHelper";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const CONTROLLER_EXTERNAL = API_URL + "/PackageListExternal"
const EXTERNAL_GET_ALL_PACKAGES = CONTROLLER_EXTERNAL + "/GetAllPackages"
const EXTERNAL_GET_VSTS_ACCESS = CONTROLLER_EXTERNAL + "/GetPackageListBannerInfo"

const CONTROLLER_ADMIN = API_URL + "/PackageListAdmin"
const ADMIN_GET_ALL_PACKAGES = CONTROLLER_ADMIN + "/GetAll"
const ADMIN_GET_FUTURE_SUBSCRIPTION = CONTROLLER_ADMIN + "/GetFutureSubscription"
const ADMIN_UPDATE_VSTS_SUBSCRIPTION = CONTROLLER_ADMIN + "/ReactivateOrDeactivateAccess"
const ADMIN_EXTEND_VSTS_SUBSCRIPTION = CONTROLLER_ADMIN + "/ExtendSubscription"
const ADMIN_EXPORT = CONTROLLER_ADMIN + "/Export";

const ExternalGetAllPackages = (skipCount, sorting, desc) => {
    let url = UrlFilterHelper.GetFilterdUrl(EXTERNAL_GET_ALL_PACKAGES, skipCount, null, sorting, desc, null);
    return axios.get(url);
}
const GetPackageListBannerInfo = () => axios.get(EXTERNAL_GET_VSTS_ACCESS)


const AdminGetAllPackages = (filter) => {
    // let url = UrlFilterHelper.GetFilterdUrl(ADMIN_GET_ALL_PACKAGES, filter.skipCount, filter.search, filter.sorting, filter.desc, filter.filter)
    return axios.post(ADMIN_GET_ALL_PACKAGES, filter, {headers: {
        'Content-Type': 'application/json',
      }});
}

const AdminReactivateOrDeactivateVstsAccess = (dto) => {
    return axios.put(ADMIN_UPDATE_VSTS_SUBSCRIPTION, dto)
}

const AdminExtendVstsSubscription = (dto) => {
    return axios.post(ADMIN_EXTEND_VSTS_SUBSCRIPTION, dto)
}

const AdminGetFutureSubscription = (bid) => {
    return axios.get(ADMIN_GET_FUTURE_SUBSCRIPTION + "/" + bid)
}

const AdminExport = (filter) => {
    return axios.post(ADMIN_EXPORT, filter, { responseType: "blob" });
};

export const certificationPackageListService = {
    ExternalGetAllPackages,
    GetPackageListBannerInfo,
    AdminGetAllPackages,
    AdminReactivateOrDeactivateVstsAccess,
    AdminExtendVstsSubscription,
    AdminGetFutureSubscription,
    AdminExport,
}
